import { Form } from "react-final-form";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import ServiceCheckListModalFormStepOne from "./ServiceCheckListModalFormStep/ServiceCheckListModalFormStepOne";

const ServiceCheckListForm = (props) => {
  const theme = useTheme();
  const { step, setStep } = props;

  return (
    <Form onSubmit={() => {}} validateOnBlur={true}>
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="ServiceCheckListForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <ServiceCheckListModalFormStepOne {...formProps} {...props} />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default ServiceCheckListForm;
